<fuse-drawer class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100" fixed [mode]="'over'" [name]="'playerTypeDrawer'"
    [position]="'right'" #playerTypeDrawer>
    <div class="bg-card flex w-full flex-col overflow-auto">
        <!-- Header -->
        <div class="flex h-20 min-h-20 flex-row items-center bg-primary px-6 text-white">
            <mat-icon class="text-current icon-size-7" [svgIcon]="'heroicons_solid:user-group'"></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                Select Player Type
            </div>
            <button class="ml-auto" mat-icon-button (click)="playerTypeDrawer.close()">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="flex flex-col p-6">

            <!-- Membership Status -->
            <div class="mb-4">
                <div class="flex items-center gap-2">
                    @if (isMemberAtCurrentCourse) {
                    <mat-icon class="text-green-500" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                    } @else if (isMemberAtOtherCourse) {
                    <mat-icon class="text-orange-500" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                    } @else {
                    <mat-icon class="text-gray-500" [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
                    }
                    <span class="text-gray-400 text-sm" [ngClass]="membershipStatusColor">
                        {{ membershipStatusText }}
                    </span>
                </div>
            </div>

            <!-- Player Type Groups -->
            <div class="flex flex-col gap-4">
                @for (group of playerTypeGroups; track group.affiliation) {
                <div class="bg-card flex-col gap-2 rounded-lg shadow overflow-hidden" [ngClass]="{
                    'opacity-60': !group.isEnabled
                }">
                    <!-- Section Header -->
                    <div class="border-b bg-gray-50 p-2 flex flex-col">

                        <span [style.color]="group.isEnabled ? group.color : group.color + '90'"
                            class="font-semibold text-lg">{{ group.headerText }}</span>

                        <span [ngClass]="group.isEnabled ? 'text-gray-600' : 'text-gray-400'"
                            class="text-sm">{{group.headerDescription}}</span>
                    </div>

                    <!-- Player Types Grid -->
                    <div class="flex flex-col gap-2 p-4">
                        @for (playerType of group.playerTypes; track playerType.id) {
                        <div class="relative">
                            <div class="p-4" [ngClass]="{
                                'bg-gray-50 border rounded-lg cursor-pointer hover:bg-gray-100 transition-colors': group.isEnabled
                                }"
                                [style.border-color]="isPlayerTypeSelected(playerType) && group.isEnabled ? group.color : ''"
                                [style.background-color]="isPlayerTypeSelected(playerType) && group.isEnabled ? group.color + '10' : ''"
                                (click)="group.isEnabled ? selectPlayerType(playerType) : null">
                                <div class="flex flex-row justify-start items-center gap-2">
                                    <!-- Player Type Avatar -->
                                    <div class="w-8 h-8 rounded-full flex items-center justify-center text-white text-base font-medium"
                                        [style.background-color]="group.isEnabled ? group.color : group.color + '60'">
                                        {{ group.icon }}
                                    </div>

                                    <!-- Player Type Name -->
                                    <div class="text-base font-medium"
                                        [ngClass]="group.isEnabled ? 'text-gray-900' : 'text-gray-500'">
                                        {{ playerType.description }}
                                    </div>

                                    @if (isPlayerTypeSelected(playerType) && group.isEnabled) {
                                    <mat-icon class="ml-auto text-2xl"
                                        [style.color]="isPlayerTypeSelected(playerType) && group.isEnabled ? group.color : ''"
                                        [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                }
            </div>

            @if (playerTypeGroups.length === 0) {
            <div class="text-center py-8">
                <mat-icon class="text-6xl text-gray-400 mb-4" [svgIcon]="'heroicons_outline:user-group'"></mat-icon>
                <h3 class="text-lg font-medium text-gray-700 mb-2">No Player Types Available</h3>
                <p class="text-gray-500">
                    There are no player types configured for this course.
                </p>
            </div>
            }
        </div>
    </div>
</fuse-drawer>